import { 
    ButtonBuilder as DiscordButtonBuilder,
    ButtonComponentData,
    APIButtonComponent,
    ButtonStyle
} from "discord.js"

export class ButtonBuilder extends DiscordButtonBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<ButtonComponentData> | Partial<APIButtonComponent>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    override setStyle(style: "blurple" | "gray" | "green" | "red" | "link" | ButtonStyle) {
        if (style === "blurple") return super.setStyle(ButtonStyle.Primary)
        else if (style === "gray") return super.setStyle(ButtonStyle.Secondary)
        else if (style === "green") return super.setStyle(ButtonStyle.Success)
        else if (style === "red") return super.setStyle(ButtonStyle.Danger)
        else if (style === "link") return super.setStyle(ButtonStyle.Link)
        else return super.setStyle(style)
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}